<template>
  <!-- 增加修改 -->
  <a-drawer
    :maskClosable="false"
    width="70%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <tableRole v-if="open" :role="role"></tableRole>
  </a-drawer>
</template>

<script>
import tableRole from './tableRole'
export default {
  name: 'CreateForm',
  data() {
    return {
      role: '',
      open: false,
      formTitle: '',
    }
  },
  components: { tableRole },
  filters: {},
  created() {
    // this.deptOption = this.deptOptions
    // console.log(this.deptOptions, 'this.deptOptions')
    // this.getConfigKey('sys.user.initPassword').then((response) => {
    //   this.initPassword = response.msg
    // })
    // if (this.role) {
    //   pageRole({ roleKey: this.role }).then((res) => {
    //     console.log(res, '测试角色细心')
    //     if (res.data.records.length) {
    //       this.rolesId = [res.data.records[0].id]
    //     }
    //   })
    // }
    // console.log(this.role, '测试角色====')
    // if (this.userType === 1 || this.userType === 0) {
    //   this.getQu()
    // }
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      that.open = false
      that.role = ''
      // this.$confirm({
      //   title: '是否确认关闭清空数据',
      //   onOk() {
      //   },
      //   onCancel() {},
      // })
    },

    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },

    /** 新增按钮操作 */
    handleAdd(e) {
      this.formTitle = e == 'YSY00' ? '所有验收员' : e == 'SG00' ? '所有水工' : '所有用户'
      this.role = e
      this.open = true
      this.isFage = true
    },
  },
}
</script>
<style lang="less" scoped>
.form_select {
  display: flex;
  align-items: center;
  .ant-select {
    width: 300px;
    margin-right: 20px;
  }
}
</style>
